import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { getConcatClickTrackingAttributes } from '@grandvisionhq/svc-tealium/utils';
import { handleHrefClick } from '../helpers.js';

const SubMenuLinks = ({ items , className , level =1 , ariaLabel , parentTealiumAttributes ,  })=>{
     return React.createElement("ul", {
        className: classnames('site-nav-mobile-submenu__items', `site-nav-mobile-submenu__level-${level}`),
        "aria-label": ariaLabel
    }, items.map((item)=>{
        var ref, ref1, ref2, ref3;
        if (!item.label) {
            return null;
        }
        let href = '#';
        if (item.link && item.link.href) {
            href = item.link.href;
        }
        if (item.parameters && item.parameters.queryString && item.parameters.queryString.length) {
            href += item.parameters.queryString;
        }
        let action;
        if (item.parameters && item.parameters.action) {
            action = item.parameters.action;
            href = '';
        }
        const icon = (item === null || item === void 0 ? void 0 : (ref = item.parameters) === null || ref === void 0 ? void 0 : ref.icon) || '';
        const classes = classnames('site-nav-mobile-submenu__item', ((ref1 = item.link) === null || ref1 === void 0 ? void 0 : ref1.active) && 'site-nav-mobile-submenu__item--active', icon && 'site-nav-mobile-submenu__item-with-icon', className);
        const tealiumAttributes = getConcatClickTrackingAttributes(item.label, parentTealiumAttributes);
        return /*#__PURE__*/ React.createElement("li", {
            className: classes,
            key: item.label
        }, action && !href && /*#__PURE__*/ React.createElement("button", {
            className: "site-nav-mobile-submenu__link",
            onClick: action
        }, icon ? /*#__PURE__*/ React.createElement("span", {
            className: "site-nav-mobile-submenu__icon"
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: icon
        })) : null, item.label), href && /*#__PURE__*/ React.createElement("a", swcHelpers.extends({
            className: "site-nav-mobile-submenu__link",
            onClick: handleHrefClick,
            href: href,
            "data-t": ((ref2 = item.parameters) === null || ref2 === void 0 ? void 0 : ref2.testId) ? `submenu-link-${item.parameters.testId}` : undefined
        }, tealiumAttributes), icon ? /*#__PURE__*/ React.createElement("span", {
            className: "site-nav-mobile-submenu__icon"
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: icon
        })) : null, item.label), ((ref3 = item.childMenuItems) === null || ref3 === void 0 ? void 0 : ref3.length) ? /*#__PURE__*/ React.createElement(SubMenuLinks, {
            items: item.childMenuItems,
            level: 2,
            parentTealiumAttributes: tealiumAttributes
        }) : null);
    }));
};

export { SubMenuLinks as default };
//# sourceMappingURL=SubMenuLinks.js.map
